import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BankModel, BankRequest, BankResourceService, PagedBankModel } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxBankService {
  constructor(
    private bankResourceService: BankResourceService,
  ) {
  }

  getBankList(params?: {page?: number; limit?: number; query?: string; ids?: number[]}): Promise<PagedBankModel> {
    return firstValueFrom(this.bankResourceService.getBanks(params?.ids, params?.limit, params?.page, params?.query));
  }

  getBankById(id: number): Promise<BankModel> {
    return firstValueFrom(this.bankResourceService.getBankById(id));
  }

  saveBank(body: BankRequest): Promise<BankModel> {
    return firstValueFrom(this.bankResourceService.saveBank(body));
  }

  deleteBank(bankId: number): Promise<any> {
    return firstValueFrom(this.bankResourceService.removeBank(bankId));
  }

  async getBankByIds(ids: number[]): Promise<BankModel[]> {
    if (ids.length === 0) {
      return [];
    }
    const paged = await this.getBankList({ids: ids});
    return paged.list;
  }
}
